import { withInstall } from '../../utils';
import Drawer from './src/drawer.vue';

export const IDrawer = withInstall(Drawer); // 增加类型

export default IDrawer;
